import React from "react";

import HeaderBtn from "../../../../../../Components/FinalTable/components/Btns/HeaderBtn";

import { TableHeaderRow } from "../../../../../../Components/FinalTable";

const THead = () => {
  return (
    <div className="w-full">
      <TableHeaderRow>
        <HeaderBtn w={90 / 7} label=" MEDICINE" />
        <HeaderBtn w={90 / 7} label="STATUS" />
        <HeaderBtn w={90 / 7} label="TO PAY" />
        <HeaderBtn w={90 / 7} label="PAYMENT METHOD" />
        <HeaderBtn w={90 / 7} label="DOSAGE" />
        <HeaderBtn w={90 / 7} label="DATE ADDED" />
      </TableHeaderRow>
    </div>
  );
};

export default THead;
